import { h, Component } from "preact";
import { Redirect }     from "react-router";
import { withRouter }   from "react-router-dom";

@withRouter
export default class SafeRedirect extends Component {
  render({ location, to }: Props) {
    return location.pathname !== to ? <Redirect to={to} /> : null;
  }
}
